module.exports = __webpack_public_path__ + "media/images/icons/flags/PW-7f69dbf25b76f17c3a26b52a3289aa9f.svg";